/* eslint-disable */

/**
 * ChampionChallengerService.js contains all of the service functions used for the
 * Champion Challenger. It depends on axios and axios-retry to contact our API.
 *
 * @endpoints /championChallenger/:
 * 		initiate - start champion challenger
 * 		disputeCount - retrieve the dispute count
 * 		status - retrieve the number of disuptes completed
 * 		resultList - retrieve CC results
 * 		resultRetrieve - retrieve details for a specific result
 *
 * @author Sophia Frankel <sophia.frankel@quavo.com>
 */

import API from '@/services/APIService';

export default {
	name: 'ChampionChallengerService',
	/**
	 * Initiate the Champion Challenger for the given parameters.
	 * @param {Object} payload - parameters for the request body
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns response body containing a reportId corresponding to the CC instance
	 */
	initiateChampionChallenger(payload, dispatch) {
		return API.call('/championChallenger/initiate', {
			tenantId: payload.tenantId,
			clientId: "Default",
			initiatedFor: payload.initiatedFor,
			profileIdNew: payload.profileIdNew,
			startDate: payload.startDate,
			endDate: payload.endDate
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	},
	/**
	 * Retrieve the dispute count for the given parameters.
	 * @param {Object} payload - parameters for the request body
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns the dispute count for the given parameters
	 */
	retrieveDisputeCount(payload, dispatch) {
		return API.call('/championChallenger/disputeCount', {
			tenantId: payload.tenantId,
			clientId: "Default",
			profileId: payload.profileId,
			startDate: payload.startDate,
			endDate: payload.endDate
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	},
	/**
	 * Retrieve the status of the Champion Challenger based on the given tenantId and reportId
	 * @param {Object} payload - parameters for the request body
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns an object containing the expected dispute count, disputes completed, old and new profileIds, and deployedProfile flag
	 */
	retrieveStatus(payload, dispatch) {
		return API.call('/championChallenger/status', {
			tenantId: payload.tenantId,
			reportId: payload.reportId
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	},
	/**
	 * Retrieve the results of the Champion Challenger based on the given tenantId and reportId
	 * @param {Object} payload - parameters for the request body
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns an object containing the reportId and the result list
	 */
	retrieveResultList(payload, dispatch) {
		return API.call('/championChallenger/resultList', {
			tenantId: payload.tenantId,
			reportId: payload.reportId
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	},
	/**
	 * Retrieve the details for a specific result from Champion Challenger based on the given tenantId, requestId, and requestSubId
	 * @param {Object} payload - parameters for the request body
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns an object containing the externalDisputeId, decisionOld, and decisionNew
	 */
	retrieveResultDetails(payload, dispatch) {
		return API.call('/championChallenger/resultRetrieve', {
			tenantId: payload.tenantId,
			RequestId: payload.RequestId,
			RequestSubId: payload.RequestSubId
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	}
};